import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import Breadcrumb from '../../../components/partials/Breadcrumb';
import { MdOutlineInventory } from "react-icons/md";
import { Alerts, GetProducts } from '../../../helpers';

const breadcrumbs = [
  {
    id: 1,
    label: "Dashboard",
    link: "/",
  },
  {
    id: 2,
    label: "Product Import",
    link: "/app/inventory",
  }
];

const VariationProduct = () => {
  const [errors, setError] = useState([]);

  // Yup validation schema
  const validationSchema = Yup.object().shape({
    productType: Yup.string()
      .required('Product type is required')
      .oneOf(['variation_product', 'normal_product'], 'Invalid product type'),
    file: Yup.mixed()
      .required('File is required')
      .test(
        'fileType',
        'Please upload a valid CSV file',
        (value) => value && value.type === 'text/csv'
      )
  });

  // Handle form submission
  const handleSubmit = async (values, { resetForm, setSubmitting  }) => {
    const { file, productType } = values;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('productType', productType);

    try {
      if (values.productType === 'variation_product') {
        const resp = await GetProducts.importVariationProduct(formData);
        if (resp && resp.status) {
          Alerts.alertMessage(resp.message, 'top-right', 'success');
          setSubmitting(false);
          resetForm();
        } else {
          setError(resp.errors);
          setSubmitting(false);
        }
      } else if (values.productType === 'normal_product') {
        const resp = await GetProducts.importSimpleProduct(formData);
        if (resp && resp.status) {
          Alerts.alertMessage(resp.message, 'top-right', 'success');
          setSubmitting(false);
          resetForm();
        } else {
          setError(resp.errors);
          setSubmitting(false);
        }
      }
    } catch (err) {
      console.log(err);
      // setError('An error occurred while uploading the file.');
    }
  };

  return (
    <>

      <div className="innerPageWrapper">
        <div className='container-fluid'>
          <div className='page-title'>
            <h2>
              <MdOutlineInventory />
              Product Import
            </h2>
          </div>
          <div className='importWrapper'>
            <div className='row'>
              <div className='col-md-6'>
                <div className="card">
                  <div className="card-header">Variation Product</div>
                  <div className="card-body">
                    <Formik
                      initialValues={{ file: null, productType: '' }}
                      validationSchema={validationSchema}
                      onSubmit={handleSubmit}
                    >
                      {({ setFieldValue, isSubmitting  }) => (
                        <Form>
                          <div className='form-group'>
                            <label htmlFor="productType">Product Type</label>
                            <Field
                              as="select"
                              name="productType"
                              className='form-control'
                            >
                              <option value="">---select type---</option>
                              <option value="variation_product">Variation Product</option>
                              <option value="normal_product">Simple Product</option>
                            </Field>
                            <ErrorMessage name="productType" component="div" className="help-error" />
                          </div>

                          <div className='form-group'>
                            <label htmlFor="file">Upload CSV</label>
                            <input
                              id="file"
                              name="file"
                              type="file"
                              accept=".csv"
                              className="form-control"
                              onChange={(event) => {
                                setFieldValue('file', event.currentTarget.files[0]);
                              }}
                            />
                            <ErrorMessage name="file" component="div" className="help-error" />
                          </div>
                          <div className='errorBox'>
                            {errors && errors.length > 0 && <>
                              <h5>Errors</h5>
                              <ul>
                                {
                                  errors.map((error, i) => {
                                    if (error.reason && error.reason.length > 0) {
                                      return error.reason.map((reasonData, j) => {
                                        console.log(reasonData.message);
                                        return (
                                          <li className="help-error" key={i + '-' + j}>
                                            {reasonData.message}
                                          </li>
                                        );
                                      });
                                    }
                                    return <li className="help-error" key={i}>{error.message}</li>;
                                  })
                                }

                              </ul>
                            </>

                            }
                          </div>



                          <button type="submit" className='btn btn-primary btn-sm' disabled={isSubmitting}>
                             {isSubmitting ? 'Uploading...' : 'Upload Now'}
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>

              </div>
              <div className='col-md-6'>
                {/* You can add preview/upload instructions here */}
              </div>
            </div>

          </div>

        </div>
      </div>
    </>
  )
}

export default VariationProduct;
